<template>
  <div>
    <AiHead></AiHead>
    <AIMenu></AIMenu>
    <AINewBasic></AINewBasic>
    <AiPersonalCenter></AiPersonalCenter>
    <AiPersonalOperate v-if="personalVisible"></AiPersonalOperate>
    <div class="home">
      <div class="home__item" v-for="item in aiList" :key="item.id">
        <div class="home__item__image">
          <el-image :src="item.headImg" fit="fill" style="width: 100%; height: 100%; border: 2"/>
        </div>
        <div class="home__item__p">
          <div style="font-size: 16px; font-weight: 800;">{{item.aiName}}</div>
          <div style="font-size: 12px; margin-top: 10px;">{{item.aiDesc}}</div>
        </div>
        <!-- 后面版本的更多区域 -->
        <!-- <div class="home__item__more"><span @click="clickMore(item.id)">...</span></div> -->
        <div class="home__item__more"><i class="el-icon-delete" @click="clickMore(item.id)"></i></div>
      </div>
    </div>
  </div>
</template>
<script>
  import AiHead from '../components/AI-Head.vue'
  import AIMenu from '../components/AI-Menu.vue'
  import AINewBasic from '../components/AI-New-Basic.vue'
  import AiPersonalCenter from '../components/AI-Personal-Center'
  import AiPersonalOperate from '../components/AI-Personal-Operate.vue'
  export default {
    name: 'Home',
    components: {
      AiHead,
      AIMenu,
      AINewBasic,
      AiPersonalOperate,
      AiPersonalCenter
    },
    data() {
      return {
        loggedVisible: false,
        visible: false,
        aiList: [],
      };
    },
    methods: {
      getMyList() {
        const userId = localStorage.getItem('userId')
        this.$http.get(`/aigenai/allAi/getMyList/${userId}`).then(
          res => {
            if (res.code !== 0) {return}
            this.aiList = []
            this.aiList.push(...res.data)
          }
        )
      },
      clickMore(aiId) {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(()=>{
          this.deleteAi(aiId)
        }).catch(()=>{
          this.$message({ type: 'info', message: '已取消删除' });  
        })
      },
      deleteAi(aiId){
        const userId = localStorage.getItem('userId')
        this.$http.post('/aigenai/allAi/delete', {aiId: aiId, userId: userId}).then(
          res => {
            if (res.code !== 0) {return}
            this.$message({ type: 'success', message: '删除成功!' });
            this.getMyList()
          }
        )
      }
    },
    mounted(){
      this.getMyList()
      this.$bus.$on('getAllListEmit', this.getMyList)
      this.$bus.$on('personalVisible', (visible)=>{this.personalVisible = !visible})
    },
    beforeDestroy() {
      // 销毁创建AI刷新列表
      this.$bus.$off("getAllListEmit");
      this.$bus.$off("personalVisible");
    },
}
</script>
<style lang="less" scoped>
  .home{
    position: absolute;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    top: 60px;
    left: 200px;
    &__item{
      position:relative;
      width: 180px;
      height: 220px;
      margin-left: 100px;
      margin-top: 50px;
      cursor: pointer;
      border: 1px solid #3459e2;
      &:hover{
        border-color: #3116cc;
      }
      &__image{
        width: 120px; 
        height: 100px;
        text-align: center;
        margin: 20px auto;
        cursor: auto;
      }
      &__p{
        margin-left: 30px;
        cursor: auto;
      }
      /* 后面版本的更多样式 */
      /* &__more{
        font-size: 24px;
        text-align: right;
        > span{
          display: inline-block;
          transform: rotate(90deg);
        }
        :hover{
          color: #3459e2;
        }
      } */
      &__more{
        position: absolute;
        font-size: 16px;
        bottom: 0px;
        right: 0;
      }
    }
  }
    
</style>